import styled from 'styled-components';
import { Accordion } from 'react-bootstrap';
import ArrowBlue from '../../images/arrow-blue.png';
import ArrowDwn from '../../images/arrow-green-down.png';
import ArrowUp from '../../images/arrow-green-up.png';

export const MainDiv = styled.div`
  color: #666;
  font-family: 'Gotham-Book', arial, sans-serif;
  font-size: 15px;
  line-height: 24px;
  letter-spacing: 0.02em;

  @media (max-width: 767px) {
    font-size: 15px;
    line-height: 22px;
  }
`;
export const AccordionContainer = styled(Accordion)``;
export const AccordionItem = styled(Accordion.Item)`
  @media print {
    .accordion-collapse {
      display: block !important;
      height: auto !important;
    }
  }
  border: none !important;
`;
export const AccordionHeader = styled(Accordion.Header)`
  border-bottom: 1px solid #e5e5e5;
  margin-bottom: 0 !important;
  button {
    font-family: 'Gotham-Book', arial, sans-serif;
    font-weight: normal !important;
    color: #33a23c;
    font-size: 18px;
    line-height: 22px;
    letter-spacing: 0.02em;
    :hover {
      background-color: #f5f5f5;
      text-decoration: none;
      color: #0397d6;
    }
    ::after {
      width: 40px;
      background: #fff url(${ArrowDwn}) no-repeat center right;
      padding-left: 50px;
      background-size: 39px auto;
    }
  }
  .accordion-button: not(.collapsed) {
    color: #0c4724 !important;
    background-color: #fff;
    ::after {
      background: #fff url(${ArrowUp}) no-repeat center right;
      padding-left: 50px;
      background-size: 39px auto;
      transform: none;
    }
  }
  .accordion-button:focus {
    box-shadow: none;
    border-color: none;
  }
  .accordion-button:hover {
    background-color: #f5f5f5;
    ::after {
      background-color: #f5f5f5;
    }
  }
  .accordion-button:active {
    color: #0c4724;
  }
`;
export const AccordionBody = styled(Accordion.Body)`
  color: #666;
  font-family: 'Gotham-Book', arial, sans-serif;
  font-size: 15px;
  line-height: 24px;
  letter-spacing: 0.02em;
  margin: 20px 0 0 0;
  padding: 0 20px !important;
`;
export const ParaText = styled.p`
  color: #666;
  font-family: 'Gotham-Book', arial, sans-serif;
  font-size: 15px;
  line-height: 24px;
  letter-spacing: 0.02em;
  position: relative;
  margin-bottom: 20px;
  @media (max-width: 767px) {
    overflow-wrap: break-word;
  }
`;
export const ListContainer = styled.ul`
  padding: 0;
  margin: 0 0 30px 0;
`;
export const OrderedList = styled.ol`
  margin: 0 0 30px 0;
  padding: 0;
  list-style-type: none;
  counter-reset: standard-counter;
  li {
    position: relative;
    margin: 0;
    padding: 15px 0 15px 50px;
    border-bottom: 1px solid #d9d9d9;
    overflow: hidden;
    background: none !important;
    :last-child {
      border-bottom: none;
    }
    ::before {
      content: counter(standard-counter);
      counter-increment: standard-counter;
      position: absolute;
      left: 0;
      top: 13px;
      width: 30px;
      height: 30px;
      text-align: center;
      padding: 5px 0 0 0;
      font-family: 'Gotham-Bold', arial, sans-serif;
      font-size: 18px;
      line-height: 18px;
      color: #0397d6;
      border: 2px solid #0397d6;
      border-radius: 50%;
    }
  }
`;

export const ListText = styled.li`
  margin: 0;
  padding: 4px 0 4px 25px;
  list-style: none;
  background: url(${ArrowBlue}) no-repeat 0 10px;
  background-size: 7px auto;
  ${ParaText} {
    margin-bottom: 0;
  }
`;
export const LinkStyle = styled.a`
  font-family: 'Gotham-Book', arial, sans-serif;
  font-size: 15px;
  line-height: 24px;
  letter-spacing: 0.02em;
  cursor: pointer;
  text-decoration: none;
  color: #1fb25a;
  transition: color 0.15s ease-out;
  :hover {
    color: #0397d6;
  }
`;
export const Header1 = styled.h1`
  margin: 0 0 35px 0;
  padding: 0;
  font-family: 'Gotham-Light', arial, sans-serif;
  font-weight: normal !important;
  font-size: 45px;
  line-height: 50px;
  color: #083a81;
  @media (max-width: 991px) {
    padding-top: 10px;
  }
  @media (max-width: 767px) {
    font-size: 30px;
    line-height: 35px;
  }
`;
export const Header2 = styled.h2`
  margin: 0 0 35px 0;
  margin-top: 35px;
  padding: 0;
  font-family: 'Gotham-Light', arial, sans-serif;
  font-weight: normal !important;
  font-size: 35px;
  line-height: 40px;
  color: #0069aa;
  @media (max-width: 767px) {
    font-size: 25px;
    line-height: 30px;
    margin-bottom: 20px;
  }
`;
export const SpanStyle = styled.span`
  position: relative;
  top: -105px;
  @media (max-width: 991px) {
    top: -80px;
  }
  @media (max-width: 767px) {
    top: -70px;
  }
`;
export const VideoContainer = styled.div`
  position: relative;
  width: 100%;
  padding-bottom: 56%;
  margin: 40px 0 40px 0;
`;

export const Iframe = styled.iframe`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  box-shadow: 0 1px 3px #969696;
`;

export const ImageStyle = styled.img`
  height: auto !important;
  width: auto !important;
  border: 0;
  vertical-align: top;
  margin: 0 0 30px 0;
  padding: 0;
  @media (max-width: 399px) {
    width: 100% !important;
    height: auto !important;
  }
`;
